// extracted by mini-css-extract-plugin
export var clearIcon = "f0_mn";
export var input = "f0_kV";
export var inputPrefixed = "f0_mS";
export var inputWrapper = "f0_k6";
export var invalid = "f0_mQ";
export var large = "f0_b2";
export var medium = "f0_b3";
export var prefix = "f0_mP";
export var xmedium = "f0_mR";